import { Button } from '@/common/ui/button'
import { Link } from 'react-router-dom'
import { Pencil } from 'lucide-react'
import { useIsCurrentUserGroup } from '@/modules/manage-member/hooks/useIsCurrentUserGroup'

interface EditGroupProps {
	id: string
}

export default function EditGroup({ id }: EditGroupProps) {
	const isCurrentUserGroup = useIsCurrentUserGroup(id)

	if (isCurrentUserGroup) return null

	return (
		<Link to={`/operator/member-group-list/${id}`}>
			<Button variant="ghost" size="icon">
				<Pencil className="h-4 w-4" />
			</Button>
		</Link>
	)
}
